import { Button, Spinner } from 'avo-ui'
import { PromoContainer } from '../../../containers/general-settings/search-page/promo/PromoContainer'
import { PopularBrandContainer } from '../../../containers/general-settings/search-page/popular-brand/PopularBrandContainer'
import { PopularProductContainer } from '../../../containers/general-settings/search-page/popular-product/PopularProductContainer'

export const SearchPage = ({ sectionProps, isLoading, isUpdating, onSubmit }) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex flex-col space-y-6'}>
                        <PromoContainer {...sectionProps} />
                        <PopularBrandContainer {...sectionProps} />
                        <PopularProductContainer {...sectionProps} />
                    </div>
                    <div className={'flex py-3 justify-center'}>
                        <Button className={'w-[200px]'} loading={isUpdating} title={'Submit'} onClick={onSubmit} />
                    </div>
                </>
            )}
        </div>
    )
}
